import EFPicture from '@elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function C() {
    const { useLang, Link } = useGlobal();
    const { t } = useLang('vanlife');
    const items: any[] = [
        {
            title: t('secC_item1_title'),
            link: t('secC_item1_link'),
            desc: t('secC_item1_desc'),
            img: '/responsive/picture/vanlife/3_1.jpg',
        },
        {
            title: t('secC_item2_title'),
            link: t('secC_item2_link'),
            desc: t('secC_item2_desc'),
            img: '/responsive/picture/vanlife/3_2.jpg',
        },
        {
            title: t('secC_item3_title'),
            link: t('secC_item3_link'),
            desc: t('secC_item3_desc'),
            img: '/responsive/picture/vanlife/3_3.jpg',
        },
        {
            title: t('secC_item4_title'),
            link: t('secC_item4_link'),
            desc: t('secC_item4_desc'),
            img: '/responsive/picture/vanlife/3_4.jpg',
        },
        {
            title: t('secC_item5_title'),
            link: t('secC_item5_link'),
            desc: t('secC_item5_desc'),
            img: '/responsive/picture/vanlife/3_5.jpg',
        },
    ];
    return (
        <div id="vanlife-C" className={`vanlife-C ${css['vanlife-C']}`}>
            <h2 className="title">{t('secC_title')}</h2>
            <p className="text">{t('secC_desc')}</p>
            <ul className="items">
                {items?.map((item: any, k: number) => (
                    <li id={`vanlife-C-${k + 1}`} className="item" key={k}>
                        <h3 className="item-title">{item.title}</h3>
                        <figure className="item-content">
                            <section className="item-media">
                                <div className="item-img">
                                    <EFPicture src={item.img} alt={item.title} />
                                </div>
                                <p className="item-quote">
                                    <span className="quote caption">{t('common_quote')}</span>
                                    <Link href={item.link} className="item-link caption">
                                        {item.link}
                                    </Link>
                                </p>
                            </section>
                            <article className="item-desc text">{item.desc}</article>
                        </figure>
                    </li>
                ))}
            </ul>
        </div>
    );
}
